import normalizeFormToStringValues from "components/helpers/normalizeFormToStringValues";

export default class AbstractFieldsValidator {
    constructor(fields, options = {}) {
        this.errors = {};
        this.fields = normalizeFormToStringValues(fields);
        this.options = options;
    }

    validate() {
        this.doCheckForSingleValue();
        this.doCheckForRelations();
        return this.errors;
    }

    doCheckForSingleValue() {

    }

    addError = (fieldKey, error) => {
        this.errors[fieldKey] = this.errors[fieldKey] || error;
    };

    pushError = (fieldKey, fieldName, error) => {
        this.errors = {
            [fieldKey]: {
                ...this.errors[fieldKey],
                [fieldName]: error,
            }
        }
    };

    doCheckForRelations() {

    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/validation/AbstractFieldsValidator.js